import { render } from "./confirmaciónasistencia_ingles.vue?vue&type=template&id=6ef0e3b6&scoped=true"
import script from "./confirmaciónasistencia_ingles.vue?vue&type=script&lang=js"
export * from "./confirmaciónasistencia_ingles.vue?vue&type=script&lang=js"

import "./confirmaciónasistencia_ingles.vue?vue&type=style&index=0&id=6ef0e3b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef0e3b6"]])

export default __exports__